module.exports = __webpack_public_path__ + "static/media/dedline-projects.8294cf07.png";